import { X } from "lucide-react";

export function Label({ children }) {
  return <label className="text-xs font-bold tracking-[0.2em] uppercase text-zinc-400">{children}</label>;
}

export function Input(props) {
  return (
    <input
      {...props}
      className={`w-full bg-zinc-950 border border-zinc-700 focus:border-yellow-400 outline-none px-3 py-2.5 text-zinc-100 text-sm transition-colors duration-200 ${props.className || ""}`}
    />
  );
}

export function Textarea(props) {
  return (
    <textarea
      {...props}
      className={`w-full bg-zinc-950 border border-zinc-700 focus:border-yellow-400 outline-none px-3 py-2.5 text-zinc-100 text-sm leading-relaxed transition-colors duration-200 ${props.className || ""}`}
    />
  );
}

export function Select(props) {
  return (
    <select
      {...props}
      className={`w-full bg-zinc-950 border border-zinc-700 focus:border-yellow-400 outline-none px-3 py-2.5 text-zinc-100 text-sm transition-colors duration-200 ${props.className || ""}`}
    />
  );
}

export function PrimaryBtn({ children, ...props }) {
  return (
    <button
      {...props}
      className={`inline-flex items-center justify-center gap-2 bg-yellow-400 text-zinc-950 font-bold text-xs tracking-[0.15em] uppercase px-5 py-3 hover:bg-yellow-300 transition-colors duration-200 disabled:opacity-50 ${props.className || ""}`}
    >
      {children}
    </button>
  );
}

export function GhostBtn({ children, ...props }) {
  return (
    <button
      {...props}
      className={`inline-flex items-center justify-center gap-2 border border-zinc-700 text-zinc-300 font-bold text-xs tracking-[0.15em] uppercase px-5 py-3 hover:border-zinc-500 hover:text-zinc-100 transition-colors duration-200 disabled:opacity-50 ${props.className || ""}`}
    >
      {children}
    </button>
  );
}

export function Modal({ title, onClose, children, testid }) {
  return (
    <div className="fixed inset-0 z-50 flex items-start sm:items-center justify-center p-4 bg-zinc-950/80 backdrop-blur-sm overflow-y-auto">
      <div className="w-full max-w-2xl my-8 max-h-[90vh] flex flex-col border border-zinc-800 bg-zinc-900" data-testid={testid}>
        <div className="flex items-center justify-between p-5 border-b border-zinc-800 shrink-0">
          <h3 className="font-heading text-xl font-bold uppercase text-zinc-50">{title}</h3>
          <button onClick={onClose} data-testid={testid ? `${testid}-close` : "modal-close"} className="text-zinc-400 hover:text-zinc-100 transition-colors duration-200">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="p-5 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
